<template>
    <billing-layout>
         <div class="messageBox" v-show="start_estimate" v-bind:class="{show: start_estimate}">
            <div class="box">
                <div class="conte">
                    <i class="fas fa-exclamation-triangle"></i>
                   <p>You want to change the start of the numeration of your Estimates?. Do it now or click Cancel. </p>
                   <button class="btn btn-success" style="margin-right:5px;" @click="activateStartUpdate">Update Start Number</button>
                   <button class="btn btn-primary"  @click="activateStartEstimate">Cancel</button>
                   <Loader v-show="isLoadingstart"></Loader>
                   
                </div>
            </div>
        </div>
<div class="container-fluid">
<form @submit.prevent="saveEstimates">
<div class="card">
    <div class="alert alert-danger" role="alert" v-if="errors.length">
    <ul style="margin-bottom: 0;">
        <li v-for="error in errors" :key="error">{{ error }}</li>
    </ul>
    </div>
    <div class="card-header">

        <div class="row">
            <div class="col-6 align-self-center">
                 <h3 class="page-title">{{formEstimates.titlePage}}
                    <span v-if="formEstimates.numdoc!=null"># {{ formEstimates.numdoc }} 
                      <NotesAdmin type='Estimate' :id="formEstimates.idEst" />
                    </span>
                  </h3>
            </div>
            <div class="col-6 text-right">
                <button type="submit" class="btn btn-success "><i class="fas fa-save"></i> SAVE</button>
                <button type="button" class="btn btn-secundary" style="margin-right:5px;margin-left:5px;" @click="$router.push({name : 'Estimates'})"><i class="fas fa-times"></i> CANCEL</button>
                <button type="button" class="btn btn-danger" @click="MetDeleteEstimate(formEstimates.idEst)" v-if="formEstimates.actionNname =='update'"><i class="fas fa-trash-alt"></i> DELETE</button>

            </div>
        </div>
  </div>
<div class="card-body">
<div class="bgloading" v-show="isLoading"><Loader></Loader></div>

  <div class="row">
    <div class="col-12">
    <div class="row">
       <div class="col-md-12 col-xl-10 offset-xl-1 col-lg-12">
          <div class="row">
        <div style="background-color:#f1f1f1; padding:8px; display:flex; margin-bottom: 12px;" class="col-12">
            <div class="col-2">
            <label for="inputEmail4">Status</label>
            <select name="" id="" class="form-control" v-model="formEstimates.status">
                <option :value="1">Pending</option>
                <option :value="2">Accepted</option>
                <option :value="3">Rejected</option>
                <option :value="4">Void</option>
            </select>
            </div>
            <div class="col-6">
            <label for="inputEmail4">Accepted By</label>
            <input type="text" class="form-control" v-model="formEstimates.accepted_by">
            </div>
            <div class="col-4">
            <label for="inputEmail4">Accepted Date</label>
            <datetime v-model="formEstimates.accepted_date" input-class="form-control" value-zone="America/New_York"></datetime>
            </div>
        </div>
             <div class="col-5">
     <label for="inputEmail4" style="position:relative; width:100%; display:block;">Customer <span style="position:absolute; right:0; top:3px;">
        <button type="button" @click="NewCustomer" class="btnlink"><i class="fas fa-plus"></i> New Customer</button>
         </span> </label>
       <div class="form-group" id="CustomersList">
           <model-select :options="CustomersList"
            v-model="ValuesCustomers"
            placeholder="Choose a Customer">
            </model-select>
         
       </div>
        </div>
    <div class="col-5">
        <label for="inputEmail4" >Estimate Name (Optional) </label>
        <input type="text" class="form-control" v-model="formEstimates.estimates_optional">
    </div>


 <div class="col-5">
 <label for="inputEmail4">Bill To</label>
 <div class="form-group bill_to">
{{ValuesCustomers.customer_name}} {{ValuesCustomers.customer_lastname}}<br>
<div v-if="ValuesCustomers.customer_address !== ''">{{ValuesCustomers.billing_address}}</div>
{{ValuesCustomers.city}} {{ValuesCustomers.state}}, {{ValuesCustomers.code}} <br>
{{ValuesCustomers.customer_phone}}  <br>
{{ValuesCustomers.email}} 
  </div>
        </div>
        <div class="col-5">
            <label for="inputEmail4" v-if="jobinfomationcheck">{{ jobinfomationtitle }}</label>
        <textarea name="" id="job_information" cols="30"  rows="2" class="form-control" v-model="formEstimates.job_information" v-if="jobinfomationcheck"></textarea>
        </div>
        <div class="col-2">
            <label for="inputEmail4">Date</label>
        <datetime type='date' v-model="inputFecha" input-class="form-control" value-zone="America/New_York"></datetime>
        </div>
        <div class="table-productos">
            <table class="table table-striped" style="margin-top:10px;">
                <thead style="background-color:#cfd8dc">
                    <tr>
                      <th scope="col">PRODUCT/SERVICE</th>
                      <th scope="col">DESCRIPTION</th>
                      <th scope="col" style="text-align: right;">QTY</th>
                      <th scope="col" style="text-align: right;">UNIT COST</th>
                      <th scope="col" style="text-align: center;">TAX</th>
                      <th scope="col" style="text-align: center;">PRICE</th>
                    </tr>
                </thead>
                <draggable 
                  v-model="formList.items" 
                  tag="tbody" 
                  class="tbody"
                  v-bind="dragOptions"
                  @start="isDragging = true"
                  @end="isDragging = false"
                  handle=".handle"
                >
                    <tr v-for="(item, index) in formList.items" :key="index">
                      <th scope="row" style="position:relative">
                        <div class="btnmove handle" ><i class="fas fa-ellipsis-v"></i></div>
                        <model-select :options="item.options" v-model="item.model" placeholder="Choose a Products"  class="productos"></model-select>
                        <div class="btninv" @click="NewProducts(item,index)">+</div>
                      </th>
                      <td><textarea name="" id="" cols="30"  rows="2" class="form-control" v-model="item.model.descripcion"></textarea></td>
                      <td style="width:70px; text-align:right"><input type="text" class="form-control"  placeholder="1" v-model="item.model.qty" style="text-align:right"></td>
                      <td style="width:120px"><input type="text" class="form-control" v-model="item.model.unitcost" placeholder="0.00" style="text-align:right" @focus="vEntero" @focusout="vDecimal"></td>
                      <td>
                          <select name="" id="" class="form-control" v-model="item.model.taxOpc">
                              <option :value="0" selected>--None--</option>
                              <option v-for="(t,index) in item.taxlistOption" :key="index" :value="t">{{t.initialstate}} {{t.name}}%</option>
                          </select>

                      </td>
                      <td style="position:relative; text-align:right">{{Number(item.model.qty) * Number(item.model.unitcost.replace(',', '')) | formatMoney}}
                           <span class="deletebtn" @click="removeItem(index)">x</span></td>
                    </tr>
                    <tr>
                        <th scope="row" class="text-left"><button type="button" class="btn btn-success btn-sm" @click="addNewLine">Add new line</button></th>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                </tr>
              </draggable>
          </table>
        </div>
    <div class="blockMont" style="display:flex; justify-content: space-between; width: 100%;">
        <div style="width:50%">
            <textarea name="" id="" cols="30"  rows="4" class="form-control" v-model="formEstimates.customer_message" placeholder="Customer message"></textarea>
        </div>
        <div style="width:50%">
            <table style="float: right;">

                <tr>
                    <td align="right">
                        <div style="padding-right:10px; font-size:15px;"><b> SubTotal </b></div>
                        </td>
                    <td align="right">
                         <div style="font-size:18px;"> {{subTotal | formatMoney}}
                            <input type="hidden" class="form-control" v-model="formEstimates.sub_Total">
                        </div>
                    </td>
                </tr>
                <tr v-for="(iva,index) in taxesResumen" :key="index" >
                  <td colspan="2">
                    <table width="100%">
                      <tr v-if="iva.total > 0">
                        <td align="left">
                          <div style="padding-right:10px;">
                            <b> <span>{{iva.name}}</span> ({{iva.porcentaje}}%) </b>
                          </div>
                        </td>
                        <td align="right">
                          {{Number(iva.total) | formatMoney}}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                    <td align="right">
                        <div style="font-size:16px; padding-right:10px;"><b> Total</b></div>
                    </td>
                    <td align="right">
                        <div style="font-size:18px;">{{total | formatMoney}}
                        <input type="hidden" class="form-control" v-model="formEstimates.total">
                       </div>
                    </td>
                </tr>

            </table>
            
        </div>
        
    </div>
     <div class="pageSignature">
         <div class="form-inline" style="border-bottom: 1px solid #ccc;">
            <div class="my-1 mr-2">Need a Contract? </div>
            <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox" class="custom-control-input" id="customControlInline" v-model="formEstimates.checked">
                <label class="custom-control-label" for="customControlInline">Yes</label>
            </div>
            <div class="form-group" v-if="formEstimates.checked" style="margin-right:5px; margin-left:15px;">
            <input type="text" class="form-control" v-model="selectCTemplate.title" placeholder="Terms & Conditions">
            </div>
            <div class="form-group" v-if="formEstimates.checked">
                <select class="form-control my-1 mr-2" id="exampleFormControlSelect1" style="width:360px;margin-top:10px;" v-model="selectCTemplate">
                <option :value="0" selected>Select template</option>
                <option v-for="i in ContractTemLists" :key="i.id" :value="i">{{i.title}} <span v-if="i.alias !== null">- {{i.alias}}</span></option>
                </select>
            </div>
        </div>
        
         <vue-editor v-model="selectCTemplate.description" v-if="formEstimates.checked" />
          <h5  style="padding-top:20px;" v-if="formEstimates.checked">Signature:</h5>
         <div class="row" v-if="formEstimates.checked">
            <div class="col">
                  <div class="form-group row">
                    <label for="" class="col-sm-2 col-form-label">Name</label>
                    <div class="col-sm-10">
                   <input type="text" class="form-control" id="" v-model="ValuesCustomers.text">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="" class="col-sm-2 col-form-label">Date</label>
                    <div class="col-sm-10">
                        <datetime type='date' v-model="dateCustomer" input-class="form-control"></datetime>
                   
                    </div>
                </div>
            </div>
            <div class="col">
                 <div class="form-group row">
                    <label for="" class="col-sm-2 col-form-label">Name</label>
                    <div class="col-sm-10">
                    <input type="text" class="form-control" v-model="FormSignature.nameCompany">
                    </div>
                </div>
                <div class="form-group row">
                    <label for="" class="col-sm-2 col-form-label">Date</label>
                    <div class="col-sm-10">
                        <datetime type='date' v-model="FormSignature.dateCompany" input-class="form-control"></datetime>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="width: 100%; text-align: right; margin-top: 20px;">
        <button type="submit" class="btn btn-success"><i class="fas fa-save"></i> SAVE</button>
        <button type="button" class="btn btn-secundary" style="margin-right:10px;margin-left:10px;" @click="$router.push({name : 'Estimates'})"><i class="fas fa-times"></i> CANCEL</button>
        <button type="button" class="btn btn-danger" @click="$router.push({name : 'Estimates'})" v-if="formEstimates.actionNname =='update'"><i class="fas fa-trash-alt"></i> DELETE</button>
    </div>
                            
                        </div>
                    </div>
                    </div>
       
              </div>
            </div>
            
        </div>
    </div>
    </form>
</div>


  <modal name="New-Customer" height="auto" @before-close="ClosedModal">
    <div class="card">
         <div class="card-header">
         Add Customer
        </div>
 
    <div class="card-body">
      <notifications group="notiCustomer" position="top center"></notifications>
    <form @submit.prevent="saveCustomer">
    <div class="row">
        <div class="col-md-6">
        <div class="form-group">
            <label for="">First Name</label>
            <input type="text" class="form-control" v-model="formcustomer.firstname" required>
        </div>
        <div class="form-group">
            <label for="">Email</label>
            <input type="text" class="form-control" v-model="formcustomer.email" >
        </div>
        <div class="form-group">
            <label for="">Address</label>
            <input type="text" class="form-control" v-model="formcustomer.address" >
        </div>
        <div class="form-group">
            <label for="">State</label>
            <input type="text" class="form-control" v-model="formcustomer.state">
        </div>
        </div>
         <div class="col-md-6">
        <div class="form-group">
            <label for="">Last Name</label>
            <input type="text" class="form-control" v-model="formcustomer.lastname">
        </div>
        <div class="form-group">
            <label for="">Phone</label>
            <input type="text" class="form-control" v-model="formcustomer.phone">
        </div>
        <div class="form-group">
            <label for="">City</label>
            <input type="text" class="form-control" v-model="formcustomer.city">
        </div>
        <div class="form-group">
            <label for="">Zip Code</label>
            <input type="text" class="form-control" v-model="formcustomer.zip">
        </div>
        </div>
    </div>

    <div class="btn-group float-right mt-2 " role="group">
        <button type="button" class="btn btn-secundary pull-right" @click="hideModal"><i class="fas fa-save"></i> Cancel</button>
        <button type="submit" class="btn btn-success pull-right"><i class="fas fa-save"></i> Save</button>
    </div>
   
    </form>
   </div>
    
    </div>
  </modal>

 <modal name="New-Products" height="auto">
         <div class="card-header">Add Product & Service</div>
            <div class="card-body">
              <notifications group="notiMetSAddProdService" position="top center"></notifications>
              <div class="bgloading" v-if="ProdServiceisLoading"><Loader></Loader></div>
            <form @submit.prevent="MetSAddProdService" >
            <div class="form-row">
                <div class="col-12">
                <span id="emailHelp" class="form-text text-muted"> Account:</span>
    <select class="form-control" v-model="FormAddPS.account_id">
        <option value="0">--Select--</option>
        <option v-for="item in filtroTypeofAccount" :key="item.id" v-bind:value="item.id">{{item.name_account}}</option>
        </select>

                </div>
                <div class="col-12">
                <span id="" class="form-text text-muted">Name:</span>
                <input type="text" class="form-control" v-model="FormAddPS.productname" required>
                </div>
                <div class="col-12">
                <span id="" class="form-text text-muted">Quantity:</span>
                <input type="text" class="form-control" v-model="FormAddPS.quantity">
                </div>
                <div class="col-12">
                <span id="" class="form-text text-muted">Unit Cost:</span>
                <input type="text" class="form-control" v-model="FormAddPS.unitcost" @keyup="checkVatId">
                <p class="error" style="color:red;" v-if="FormAddPS.vatError">{{FormAddPS.vatErrorMsg}}</p>
                </div>
                <div class="col-12">
                    <span id="" class="form-text text-muted"> Description:</span>
                    <textarea name="" id="" cols="10" rows="2" class="form-control form-text w100" style="width:100%" v-model="FormAddPS.description"></textarea>
                </div>
                <div class="col-12">
                    <span id="" class="form-text text-muted"> Apply Tax:</span>
                <select class="form-control" v-model="FormAddPS.applytax">
                    <option value="0">0.00% -None- (NN)</option>
                    <option v-for="item in TaxesLists" :key="item.id" v-bind:value="item.id">{{item.name}}% {{item.statename}}</option>
                    </select>
                    
                    
                </div>
  
                <div class="col-12">
                    <span id="emailHelp" class="form-text text-muted">.</span>
                <button type="submit" class="btn btn-success float-right" :disabled='isDisabled'>{{FormAddPS.btnName}}</button>
                </div>
            </div>
            </form>
        <Loader v-if="isLoading"></Loader>
            </div>
        </modal>
        <modal name="modal-setting" height="auto" @before-close="ClosedModal">
            <div class="card">
            <component :is="SettingBox"></component>
            </div>
        </modal>
<notifications group="noti" position="top center">
</notifications>
    </billing-layout>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/shared/Loader'
import EventBus from '@/eventBus';
import { ModelSelect } from 'vue-search-select'
import { BasicSelect  } from 'vue-search-select'
import BillingLayout from '@/Layouts/Billing/BillingLayout'
import StartEstimate from '@/components/billing/setting/StartEstimate.vue';
import Taxes from '@/components/billing/setting/Taxes.vue'
import ClickOutside from 'vue-click-outside'
import draggable from "vuedraggable"
import { VueEditor } from "vue2-editor"
import NotesAdmin from '@/components/billing/NotesAdmin.vue';


export default {
     name:'EstiatesNew',
     display: "Table",
     order: 8,
    components:{
        Loader,
        BillingLayout,
        StartEstimate,
        Taxes,
        ModelSelect,
        BasicSelect,
        draggable,
        VueEditor,
        NotesAdmin,
    },
    
    data() {
        return{
           isLoading : true,
           isLoadingstart : false,
           errors: [],
           showModal: false,
           start_estimate : false,
           ProdServiceLists : [],
           CustomersList : [],
           TaxesLists : [],
           SettingBox : '',
           formList:{
             items: []
           },
            ValuesCustomers: {
                text: null,
                value: null,
                billing_address: null,
                bussinesname: null,
                customer_address: null,
                customer_name: null,
                customer_phone: null,
                email: null
            },
            formcustomer :{
                CustomerId : null,
                firstname : null,
                email: null,
                address : null,
                state : null,
                lastname : null,
                phone : null,
                city : null,
                zip : null,
                error: 0
            },
            formEstimates :{
                idEst : null,
                titlePage : 'Add Estimate',
                btnName : 'SAVE',
                actionNname : 'create', // update
                customer_id : null,
                numdoc : null,
                customer_name : null,
                customer_email : null,
                customer_address : null,
                billing_address : null,
                estimates_optional : null,
                status: 1,
                accepted_by : null,
                accepted_date : null,
                job_information : null,
                customer_message : null,
                date_created : new Date().toISOString().slice(0,10),
                sub_total : 0,
                total : 0,
                totaltax : null,
                qty : null,
                checked : false,
                dataItems : []
            },
            HideSuggestionProd : false,
            TypeofAccount: [],
            FormAddPS: {
                vatError : false,
                vatErrorMsg : null,
                index_modal : null,
                btnName : 'SAVE',
                Action : 'Add',
                id : null,
                productname : null,
                account_id : 0,
                quantity : 1,
                unitcost : 0,
                description : null,
                applytax : 0,
                status : 0
            },
            ContractTemLists : [] ,
            selectCTemplate :{
              title: '',
              description: '',
            },
            FormSignature: {
                //nameCustomer: null,
                dateCustomer: new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString(),
                dateCompany: new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString(),
                nameCompany: localStorage.getItem('nomCompany'),
            },
            taxesResumen:[],
            inputFecha : new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString(),
            jobinfomationcheck : true,
            jobinfomationtitle : 'Job information',
            jobinfomationtext : null,
            dateCustomer: new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString(),
            dateCompany: new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString(),
            ProdServiceisLoading: false,
      } 
    },
    beforeMount(){
      
    },
    created(){
      this.getEstimateSetting();
      this.metstartEstimate();
      this.getCustomer();
      this.getTaxes();
      this.getAccountTypes();
      this.getCTemplates();    
    },
    mounted(){
        EventBus.$on('UpdateStartEstimate', data => {
            this.$modal.hide('modal-setting')
            this.SettingBox = ''
            this.start_estimate = false;
        });

    }, 
    directives: {
    ClickOutside
    },
    methods:{
      vDecimal(e){
        //console.log('change',e.target.value);
        let val = e.target.value;
        e.target.value = this.validDecimal(val);
      },
      vEntero(e){
        let val = e.target.value;
        val = val.replace(',', '');
        //console.log('valor de focus',val);
        e.target.value = val;
      },
      validDecimal(num){
        //console.log('valor de num',num);
        //let vatIdRegex =  new RegExp(/^(0|[1-9]\d*)(\.\d+)?$/)
        let vatIdRegex =  new RegExp(/^(-{1}?(?:([0-9]{0,10}))|([0-9]{1})?(?:([0-9]{0,9})))?(?:.([0-9]{0,3}))?$/)
        let value= 0.00;
        if(vatIdRegex.test(num))
        {
          //console.log('si es entero ', num);
          if(num.indexOf(".") > -1 ){ value= num;} 
          else{
            value= num+'.00';
          }
        }
        return Number(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
      },
      edicionDuplicadosOtros(){
        if(this.$route.params.idest && !this.$route.params.duplicate){
          this.formEstimates.titlePage = 'Edit Estimate';
          this.formEstimates.actionNname = 'update';
          this.EstimateById();
        }
        if(this.$route.params.idest && this.$route.params.duplicate){
          this.formEstimates.titlePage = 'Duplicate Estimate';
          this.formEstimates.actionNname = 'duplicate';
          this.EstimateById(); 
        }
        if(this.$route.params.idc && this.$route.params.transac){
          this.getCustomer(this.$route.params.idc);
          this.addNewLinePrimary();
       }
      },
      valueOptionstax(obj){
        //reiniciar totales
        if(this.taxesResumen.length > 0){for (let e in this.taxesResumen) {this.taxesResumen[e].total = 0;}}
        for (let i in obj) {
          if(obj[i].model.taxOpc != 0){
            if(this.taxesResumen.length > 0){
              for (let e in this.taxesResumen) 
              {
                if (this.taxesResumen[e].id == obj[i].model.taxOpc.id) {
                  let unitcost = obj[i].model.unitcost.replace(',', '');
                  let total = Number(unitcost) * Number(obj[i].model.taxOpc.name) / 100 * Number(obj[i].model.qty);
                  this.taxesResumen[e].total = Number(this.taxesResumen[e].total) + Number(total);
                }
              }
            }
          }
        }
      },
        formatearFechaContrato(){
          this.dateCustomer=new Date((new Date(this.dateCustomer).toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString();
          this.dateCompany=new Date((new Date(this.dateCompany).toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString();
        },
        formatearFecha(){
         this.inputFecha= new Date((new Date(this.inputFecha).toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString()
        },
        metstartEstimate(){
            window.billing.get('startestimate/' + window.localuserdata)
                .then((response) => {
                    console.log(response.data)
                    if(response.data.start_estimate == false){
                      this.start_estimate = true;
                    }
            }).catch((error) => console.log(error));
           
        },
        activateStartUpdate(){
         this.$modal.show('modal-setting')
         this.SettingBox = 'StartEstimate'
         //this.$modal.hide('New-Products')
        },
        activateStartEstimate(){
            this.isLoadingstart = true
            window.billing.post('startestimate/add',{
                user_id : window.localuserdata,
                startnumber: '001'
            }).then((response) => {
                this.isLoadingstart = false
                this.start_estimate = false;
            }).catch((error) => console.log(error,this.isLoadingstart = false));

        },
        ClosedModal(){
            this.SettingBox =''
        },
        EstimateById() {
            this.isLoading = true;
            window.billing.get('estimate/' + this.$route.params.idest)
                .then((response) => {
                     console.log('detail estimates')
                     console.log(response.data)
                     this.formEstimates.idEst = response.data.result.id
                     this.formEstimates.numdoc = response.data.result.numdoc
                     this.formEstimates.job_information =  response.data.result.job_information
                     this.formEstimates.estimates_optional = response.data.result.estimate_optional
                     this.formEstimates.customer_message = response.data.result.customer_message
                     this.formEstimates.accepted_by = response.data.result.accepted_by
                     this.formEstimates.accepted_date = response.data.result.accepted_date
                     this.formEstimates.status = response.data.result.status
                     //this.formEstimates.date_created = (this.formEstimates.actionNname == 'duplicate') ? new Date().toISOString().slice(0,10) : response.data.result.date_create
                     this.inputFecha = (this.formEstimates.actionNname == 'duplicate') ? new Date().toISOString().slice(0,10) : response.data.result.date_create
                     this.formEstimates.checked = (response.data.result.need_contract == 1) ? true : false,
                     this.formEstimates.sub_total = response.data.result.sub_total
                     this.formEstimates.total = response.data.result.total
                     
                     this.selectCTemplate.description = response.data.result.terms_conditions_desc;
                     this.selectCTemplate.title = response.data.result.terms_conditions_title;
                     this.dateCustomer=new Date((new Date(response.data.result.signaturecustomerdate).toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString();
                     this.dateCompany=new Date((new Date(response.data.result.signaturecompanydate).toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString();
                     this.selectBillTo(response.data.customer.id);
                   
                    for(let item in response.data.itemsprod){
                      let taxfil = this.TaxesLists.filter(taxfil => taxfil.id == response.data.itemsprod[item].tax_id);
                      let newObj = taxfil.reduce((a, b) => Object.assign(a, b), {})
                      let isEmptyObj = !Object.keys(newObj).length;
                      console.log('EstimateById ProdList ',this.ProdServiceLists)
                      let unitcost=this.validDecimal(response.data.itemsprod[item].unitcost);
                        this.formList.items.push({
                            options:this.ProdServiceLists,
                            taxlistOption : this.TaxesLists,
                            model:{
                                value : response.data.itemsprod[item].product_id,
                                unitcost : unitcost,
                                text : response.data.itemsprod[item].product_name,
                                descripcion : response.data.itemsprod[item].description,
                                qty : response.data.itemsprod[item].qty,
                                taxOpc : (isEmptyObj) ? 0 : newObj
                            }
                        })
                    }
					       this.isLoading = false
                }).catch((error) => console.log(error));
        },
        getAccountTypes() {
          window.billing.get('chart-account-list/' + window.localuserdata)
          .then((response) => {
            console.log('Account type form modal es') ;
            console.log(response.data.result);
            this.TypeofAccount = response.data.result;
          }).catch((error) => console.log(error));
        },
        MetSAddProdService(){
          let x = this.formList.items[this.FormAddPS.index_modal];
          if(this.FormAddPS.unitcost == 0){
            this.FormAddPS.vatErrorMsg = "Please enter Valid Number.";
            return false;
          }
          if(this.FormAddPS.Action == 'Add'){
            this.formList.items[this.FormAddPS.index_modal].taxlistOption = this.TaxesLists;
            if(this.FormAddPS.account_id==0)
            {
              this.$notify({
                group: 'notiMetSAddProdService',
                title: 'Error',
                type: 'error',
                text: 'You must select an Account.'
              });
            }
            else
            {
              this.ProdServiceisLoading=true;
              window.billing.post('product-service/add',{
                  user_id : window.localuserdata,
                  account_id: this.FormAddPS.account_id,
                  productname: this.FormAddPS.productname,
                  quantity: this.FormAddPS.quantity,
                  unitcost: this.FormAddPS.unitcost,
                  description: this.FormAddPS.description,
                  applytax: this.FormAddPS.applytax,
                  status: 1
              }).then((response) => {
                console.log(response.data);
                //this.getProdservices();
                if(response.data.status){
                  let idTaxOpc =0;
                  for (let i in this.TaxesLists) {
                    if (this.TaxesLists[i].id==this.FormAddPS.applytax) {
                      idTaxOpc=this.TaxesLists[i];
                    }
                  }
                  let unitcost=this.validDecimal(response.data.unitcost);
                  let quantity=response.data.quantity;
                  let model = {
                    value:response.data.ProductId,
                    text:response.data.productname,
                    prodname:response.data.productname,
                    unitcost: unitcost,
                    descripcion:response.data.description,
                    qty:quantity,
                    taxOpc : idTaxOpc,
                    applytax : this.FormAddPS.applytax,
                  };
                  this.ProdServiceLists.push(model);
                  this.formList.items[this.FormAddPS.index_modal].options = this.ProdServiceLists;
                  this.formList.items[this.FormAddPS.index_modal].model = model;
                }
                this.FormAddPS.account_id= null;
                this.FormAddPS.productname = null;
                this.FormAddPS.quantity = 1;
                this.FormAddPS.unitcost = 0;
                this.FormAddPS.description = null;
                this.FormAddPS.applytax = 0;
                this.FormAddPS.status = 1;
                this.$modal.hide('New-Products');
                this.ProdServiceisLoading=true;
                this.$notify({
                  group: 'noti',
                  title: 'Created!',
                  type: 'success',
                  text: 'Add Product Successful'
                });  
              }).catch((error) => {console.log(error); this.ProdServiceisLoading=false;});
            }
          }
        },
        getCustomer(idc=0) {
            let self = this
            window.billing.get('customers/'+ window.localuserdata)
                .then((response) => {
                    console.log('customer list estimates')
                    console.log(response.data.result)
                    const Customers = []
                    if(response.data.result){
                    for(let item in response.data.result){
                        var id = response.data.result[item].id;
                        var text = response.data.result[item].firstname;
                        var billing_address = response.data.result[item].billingaddress;
                        var customer_address = response.data.result[item].address;
                        var bussinesname = response.data.result[item].bussinesname;
                        var email = response.data.result[item].email;
                        var lastname = response.data.result[item].lastname;
                        var customer_phone = response.data.result[item].officephone;
                        var city = response.data.result[item].bcity;
                        var state = response.data.result[item].bstate;
                        var code = response.data.result[item].bpostcode;
                        city = (city!=null) ? city+',' : '';
                        state = (state!=null) ? state : '';
                        code = (code!=null) ? code : '';
                        var guion = ' - '
                        this.formEstimates.customer_email = email
                        if(bussinesname == null){
                            bussinesname = '';
                            guion = ' ';
                        }
                        if( lastname == null ){
                            lastname ='';
                        }
                        Customers.push({
                          value:id,
                          text:text + ' ' + lastname + guion + bussinesname,
                          customer_name : text,
                          customer_address : customer_address,
                          customer_phone : customer_phone,
                          customer_lastname : lastname,
                          billing_address:billing_address,
                          bussinesname : bussinesname,
                          email : email,
                          city : city,
                          state : state,
                          code : code
                        });
                        if(idc > 0 && idc == id){
                          this.ValuesCustomers = {
                            text: text + ' ' + lastname + guion + bussinesname,
                            value: id,
                            billing_address: billing_address,
                            bussinesname: bussinesname,
                            customer_address: customer_address,
                            customer_name: text,
                            customer_lastname : lastname,
                            customer_phone: customer_phone,
                            email: email,
                            city : city,
                            state : state,
                            code : code
                          }
                        }
                      }
                    }
                    this.CustomersList = Customers;
                    if(idc > 0){this.isLoading = false;}
            }).catch((error) => console.log(error));
        },
        selectBillTo(idc){
          for(let item in this.CustomersList){
            let id = this.CustomersList[item].value;
            if(idc > 0 && idc == id){
                this.ValuesCustomers = {
                  text: this.CustomersList[item].text ,
                  value: this.CustomersList[item].value,
                  billing_address: this.CustomersList[item].billing_address,
                  bussinesname: this.CustomersList[item].bussinesname,
                  customer_address: this.CustomersList[item].customer_address,
                  customer_name: this.CustomersList[item].customer_name,
                  customer_lastname: this.CustomersList[item].customer_lastname,
                  customer_phone: this.CustomersList[item].customer_phone,
                  email: this.CustomersList[item].email,
                  city : this.CustomersList[item].city,
                  state : this.CustomersList[item].state,
                  code : this.CustomersList[item].code
                }
              }
          }
          console.log('customer seleccionado', this.ValuesCustomers);
        },
        
        NewCustomer(){
            this.$modal.show('New-Customer');
        },
        NewProducts(item,index){
            //console.log(item);
            this.FormAddPS.index_modal = index
            this.$modal.show('New-Products');
        },
        MetAddProd(ip,index){
         console.log(index);
         this.HideSuggestionProd = false;
         
        },
        ItemsClick(index){
         
        },
        saveCustomer(){
          window.billing.post('estimate/customer/add',{
                user_id : window.localuserdata,
                firstname: this.formcustomer.firstname,
                lastname: this.formcustomer.lastname,
                officephone: this.formcustomer.phone,
                astate: this.formcustomer.state,
                acity: this.formcustomer.city,
                address: this.formcustomer.address,
                email: this.formcustomer.email,
                apostcode: this.formcustomer.zip
           }).then((response) => {
            console.log(response.data);
                if(response.data.status){
                    let lastname = this.formcustomer.lastname;
                    lastname = (lastname!=null) ? lastname : '';
                    var city = this.formcustomer.city;
                    city = (city!=null) ? city+',' : '';
                    this.ValuesCustomers = {
                    text: this.formcustomer.firstname + ' ' + lastname,
                    value: response.data.customerId,
                    bussinesname: '',
                    billing_address: this.formcustomer.address,
                    customer_address: this.formcustomer.address,
                    customer_name: this.formcustomer.firstname,
                    customer_lastname: lastname,
                    customer_phone: this.formcustomer.phone,
                    email: this.formcustomer.email,
                    city : city,
                    state : this.formcustomer.state,
                    code : this.formcustomer.zip
                  }
                  this.FormSignature = {
                       nameCustomer : this.formcustomer.firstname + ' ' + lastname
                  }
                }
                     
                 this.getCustomer();
                 this.$notify({
                        group: 'noti',
                        title: 'Created!',
                        type: 'success',
                        text: 'Successful registration'
                    }); 
                
                this.$modal.hide('New-Customer');
                this.formcustomer = {
                    firstname : null,
                    lastname : null,
                    phone : null,
                    state : null,
                    city : null,
                    address : null,
                    email : null,
                    zip : null,
                    error: 0
                }
          }).catch((error) => console.log(error,this.isLoading = false));
        },
        saveEstimates(){
          this.isLoading = true;
          this.errors = [];
          if (!this.ValuesCustomers.value) {
            this.errors.push('Must select "Customer"');
            this.isLoading = false;
          }
          if (!this.formList.items[0].model.value) {
            this.errors.push('Must add at least 1 Product or service');
            this.isLoading = false;
          }
          if(this.ValuesCustomers.value && this.formList.items[0].model.value)
          {
            if(this.formEstimates.actionNname == 'create' || this.formEstimates.actionNname == 'duplicate' )
            {
              window.billing.post('estimates/add',{
                user_id : window.localuserdata,
                customer_id : this.ValuesCustomers.value,
                estimate_optional : this.formEstimates.estimates_optional,
                status : this.formEstimates.status,
                accepted_by : this.formEstimates.accepted_by,
                accepted_date : this.formEstimates.accepted_date,
                job_information : this.formEstimates.job_information,   
                customer_message : this.formEstimates.customer_message,
                need_contract : this.formEstimates.checked,
                terms_conditions_title : this.selectCTemplate.title,
                terms_conditions_desc : this.selectCTemplate.description,
                signaturecustomer : this.ValuesCustomers.text,
                signaturecustomerdate : this.FormSignature.dateCustomer,
                signaturecompany : this.FormSignature.nameCompany,
                signaturecompanydate : this.FormSignature.dateCompany,
                date_create : this.formEstimates.date_created,
                sub_total : this.formEstimates.sub_total,
                total : this.formEstimates.total,
                dataItems : this.formList.items
              }).then((response) => {
                this.isLoading = false;
                this.$notify({
                  group: 'noti',
                  title: 'Created!',
                  type: 'success',
                  text: 'Successful registration'
                });
                this.$router.push({ name: 'Estimates' });
              }).catch((error) => console.log(error,this.isLoading = false));
            }
            if(this.formEstimates.actionNname == 'update')
            {
              window.billing.put('estimate/edit/' + this.formEstimates.idEst,{
                user_id : window.localuserdata,
                numdoc : this.formEstimates.numdoc,
                customer_id : this.ValuesCustomers.value,
                estimate_optional : this.formEstimates.estimates_optional,
                status : this.formEstimates.status,
                accepted_by : this.formEstimates.accepted_by,
                accepted_date : this.formEstimates.accepted_date,
                job_information : this.formEstimates.job_information,
                customer_message : this.formEstimates.customer_message,
                need_contract : this.formEstimates.checked,
                terms_conditions_title : this.selectCTemplate.title,
                terms_conditions_desc : this.selectCTemplate.description,
                signaturecustomer : this.ValuesCustomers.text,
                signaturecustomerdate : this.FormSignature.dateCustomer,
                signaturecompany : this.FormSignature.nameCompany,
                signaturecompanydate : this.FormSignature.dateCompany,
                date_create : this.formEstimates.date_created,
                sub_total : this.formEstimates.sub_total,
                total : this.formEstimates.total,
                dataItems : this.formList.items
              }).then((response) => {
                this.isLoading = false;
                console.log(response.data);
                this.$notify({
                  group: 'noti',
                  title: 'Updated',
                  type: 'success',
                  text: 'Successful Updated'
                });
                this.$router.push({ name: 'Estimates' });
              }).catch((error) => console.log(error,this.isLoading = false));
            }
          }         
        },
        hideModal(){
            this.$modal.hide('New-Customer');
        },
        getTaxes() {
            window.billing.get('taxes/' + window.localuserdata)
                .then((response) => {
                    console.log('taxes request all');
                 //console.log(response.data)
                    //this.TaxesLists = response.data;
                    const ObjTaxes = []
                    if(response.data){
                        for(let item in response.data){
                            var id = response.data[item].id
                            var initialstate = response.data[item].initialstate
                            var name = response.data[item].name
                            var state_id = response.data[item].state_id
                            var statename = response.data[item].statename
                            var status = response.data[item].status
                            var user_id = response.data[item].user_id
                            ObjTaxes.push({
                                id:id,
                                initialstate:initialstate,
                                name:name,
                                state_id:state_id,
                                statename:statename,
                                status:status,
                                user_id:user_id,
                                default:'none'
                            });

                          this.taxesResumen.push({
                                id:id,
                                name:initialstate,
                                porcentaje:name,
                                initialstate:initialstate,
                                statename:statename,
                                count: 0,
                                total: 0,
                            });
                        }
                    }
                    this.TaxesLists = ObjTaxes;
                    this.getProdservices();
                }).catch((error) => console.log(error));
        },
        
        getProdservices() {
            
            window.billing.get('product-services/' + window.localuserdata)
                .then((response) => {
                    console.log('product sevice list table')
                    //this.ProdServiceLists = response.data.result
                    const ProdList = []
                    if(response.data.result){
                    for(let item in response.data.result){
                        var id = response.data.result[item].id
                        var prodname = response.data.result[item].productname;
                        var quantity = response.data.result[item].quantity
                        var unitcost = this.validDecimal(response.data.result[item].unitcost);
                        var descripcion = response.data.result[item].description
                        var applytax = response.data.result[item].applytax;
                        let taxOpcID = 0;
                        for (let i in this.TaxesLists) {
                          if (this.TaxesLists[i].id ==response.data.result[item].applytax) {
                            taxOpcID=this.TaxesLists[i];
                          }
                        }
                        ProdList.push({
                          value:id,
                          text:prodname,
                          unitcost:unitcost,
                          descripcion:descripcion,
                          qty:quantity,
                          taxOpc : taxOpcID,
                          applytax : applytax,
                        })
                      }
                    }
                   this.ProdServiceLists = ProdList;
                   console.log('ProdList ',this.ProdServiceLists)
                /// item default 1
                 console.log('params='+this.$route.params.length, this.$route.params, this.$route.name);
                if(this.$route.name != 'EstimatesNew'){
                  this.edicionDuplicadosOtros();
                }
                else
                {
                  this.addNewLinePrimary();
                  this.isLoading = false;
                }
                 
                }).catch((error) => {this.isLoading = false; console.log(error)});
        },
        addNewLinePrimary(){
          if(this.formEstimates.actionNname == 'create')
          {
            this.formList.items.push({
              options:this.ProdServiceLists,
              taxlistOption : this.TaxesLists,
              model:{
                value:'',
                text:'',
                description:'',
                unitcost:'',
                qty:1,
                taxOpc : 0,
                applytax : 0,
              }
            });
            console.log('add item');
          }
        },
        addNewLine() {
          console.log('add item');
          const ProdList = []
            for(let item in this.ProdServiceLists)
            {
              var id = this.ProdServiceLists[item].value
              var prodname = this.ProdServiceLists[item].text;
              var quantity = this.ProdServiceLists[item].qty
              var unitcost = this.validDecimal(this.ProdServiceLists[item].unitcost);
              var unitcost = this.ProdServiceLists[item].unitcost
              var descripcion = this.ProdServiceLists[item].descripcion
              var applytax = this.ProdServiceLists[item].applytax;
              let taxOpcID = 0;
              for (let i in this.TaxesLists) {
                if (this.TaxesLists[i].id ==this.ProdServiceLists[item].applytax) {
                  taxOpcID=this.TaxesLists[i];
                }
              }
              ProdList.push({
                value:id,
                text:prodname,
                unitcost:unitcost,
                descripcion:descripcion,
                qty:quantity,
                taxOpc : taxOpcID,
              });
            }
          this.formList.items.push({
              options : ProdList,
              taxlistOption : this.TaxesLists,
              model:{
                  value:'',
                  text:'',
                  description:'',
                  unitcost:'',
                  qty:1,
                  taxOpc : 0,
                  applytax : applytax,
              }
          });                            
        },
        removeItem(index) {
                this.formList.items.splice(index, 1)
        },
        hide() {
        this.HideSuggestionProd = false
        },
        getCTemplates() {
            window.billing.get('contracttemplate/' + window.localuserdata)
                .then((response) => {
                    console.log('template estimates list')
					 console.log(response.data)
                  this.ContractTemLists = response.data.result;
                }).catch((error) => console.log(error));
        },
        MetDeleteEstimate(idest){
          this.isLoading = true
          this.$swal({
            title: "Delete this Estimate?",
            text: "Are you sure?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes, Delete it!"
                }).then((result) => {
                    if (result.value) {
                        window.billing.put('estimate/delete/' + idest,{
                                user_id : window.localuserdata
                        }).then((response) => {
                             
                                this.isLoading = false;
                                    if(response.data.status){
                             this.$notify({
                                group: 'noti',
                                title: 'Deleted!',
                                type: 'success',
                                text: 'Deleted Estimate Successful'
                            }); 
                                      
                                        this.$router.push({ name: 'Estimates' })
                                    }
                                }).catch((error) => console.log(error,this.isLoading = false));
                    }
                });
      this.isLoading = false   
     },
     checkVatId() {
         //RegExp(/^[1-9]+/) ?|0+\.[1-9][0-9]
      let vatIdRegex =  new RegExp(/^(0|[1-9]\d*)(\.\d+)?$/)
      if (this.FormAddPS.unitcost == ''){
        this.FormAddPS.vatError = true;
        this.FormAddPS.vatErrorMsg = "Enter positive number.";
      } else if(!vatIdRegex.test(this.FormAddPS.unitcost)) {
        this.FormAddPS.vatError = true;
          
        this.FormAddPS.vatErrorMsg = "Please enter Valid Number.";
        //this.FormAddPS.unitcost = 0;
      } else {
        this.FormAddPS.vatError = false;
      }
      
   },

        getEstimateSetting() {
          //this.FormestimateSetting.isLoading = true
            window.billing.get('estimates/setting/' + window.localuserdata)
                .then((response) => {
                  console.log(response.data.result);
                  if(response.data.result.length){
                    this.jobinfomationcheck = response.data.result[0].jobinfomationcheck;
                    this.jobinfomationtitle = response.data.result[0].jobinfomationtitle;
                    this.jobinfomationtext = response.data.result[0].jobinfomationtext;
                    this.formEstimates.job_information = response.data.result[0].jobinfomationtext;
                  }
                }).catch((error) => console.log(error));
        },
    },
    
    watch:{
      inputFecha: function(){
        this.formatearFecha();
        this.formEstimates.date_created =this.inputFecha;
        console.log('fecha',this.inputFecha);
      },
      dateCustomer: function(){ 
        this.formatearFechaContrato();
        this.FormSignature.dateCustomer =this.dateCustome;
        this.FormSignature.dateCompany =this.dateCompany;
        console.log('fecha de contratos ',this.FormSignature);
      },
      dateCompany: function(){ 
        this.formatearFechaContrato();
        this.FormSignature.dateCustomer =this.dateCustome;
        this.FormSignature.dateCompany =this.dateCompany;
        console.log('fecha de contratos ',this.FormSignature);
      },      
      formcustomer: {
        deep: true,
        handler: (e) => {
          //debugger;
          for(var i in e){
            if(i!='notes' && i!='error'){
              if(e[i]!=null && e[i].length > 0){
                if(e[i].indexOf(',') > -1){
                  //console.log(i, e[i]);
                  e['error']=parseInt(e['error'])+1;
                  e[i] = e[i].replace(",", "");
                  console.log(e);
                }
              }
            }  
          }          
        }
      },
      "formcustomer.error": function(e) {
        if(e> 0){
          this.$notify({
            group: 'notiCustomer',
            title: 'Error',
            type: 'error',
            text: 'The symbol coma “,” is not allowed.'
          });
          return e=0;
        }
      },
    },
    computed: {
        
        subTotal() {
            return this.formList.items.reduce((carry, item) => {
                let unitcost = item.model.unitcost.replace(',', '');
                this.formEstimates.sub_total = carry + (Number(unitcost) * Number(item.model.qty))
                return carry + (Number(unitcost) * Number(item.model.qty))
            }, 0)
        },
        TotalTax() {
            return this.formList.items.reduce((c, i) => {
                let unitcost = i.model.unitcost.replace(',', '');
                if(i.model.taxOpc ==0){
                   return this.formEstimates.totaltax = c + (Number(unitcost) * Number(i.model.taxOpc)) / 100 * Number(i.model.qty)
                }
              return this.formEstimates.totaltax = c + (Number(unitcost) * Number(i.model.taxOpc.name)) / 100 * Number(i.model.qty)
            }, 0)
            
        },
        total() {
            this.valueOptionstax(this.formList.items);
            this.formEstimates.total = Number(this.subTotal) + this.TotalTax;
            return Number(this.subTotal) + this.TotalTax;

        },
        filtroTypeofAccount() {
        return this.TypeofAccount.filter(function(u) {
            return u.account_type === 3 || u.account_type === 5
        })
      },
      isDisabled: function(){
          if(this.FormAddPS.unitcost == 0){
            return this.FormAddPS.unitcost;
          }
    	
      },
      dragOptions() {
          return {
            animation: 200,
            group: "description",
            disabled: false,
            ghostClass: "ghost"
          };
        }
    },
};
</script>
<style lang="scss" scoped>
.iva_block{
    display:flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    padding-top: 5px;
    padding-bottom: 5px;
    .itemsb{
        display: flex;
        justify-content: flex-end;
        width: 100%;
    }
}
.deletebtn{
    position: absolute;
    right: -24px;
    top: 22px;
    width: 24px;
    height: 20px;
    background-color: #f12e2e;
    cursor: pointer;
    font-size: 20px;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    padding: 7px;
    line-height: 0px;
   &:hover{
       background-color: #c12727;
   }
}
.pageSignature{
    display:block;
    margin-top: 20px;
    width: 100%;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #A0A0A0;
}
.ui.fluid.search.selection.dropdown.productos {
    width: 90%;
    float: left;
    display: inline-block;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}
.btninv{
  position: relative;
  left: initial;
  top: 0;
  width: 20px;
  height: 38px;
  cursor: pointer;
  background-color: #fff;
  z-index: 10;
  color: #333;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  line-height: 34px;
  font-weight: 400;
  border: 1px solid #dedede;
  float: right;
  display: inline-block;
  margin-left: -6px;
    &:hover{
        background-color: #e0e0e0;
    }
}
.btnmove{
    position: absolute;
    left: -13px;
    top: -3px;
    width: 13px;
    height: 100%;
    cursor: pointer;
    background-color: #e1f2fb;
    z-index: 10;
    color: #afafaf;
    font-size: 12px;
    line-height: 75px;
    text-align: center;
    vertical-align: middle;
    font-weight: normal;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    &:hover{
        background-color: #e0e0e0;
        cursor: move;
    }
}
.table-productos {width:100%;}
.bill_to{
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.800rem;
  line-height: 1.5;
  color: #4F5467;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dedede;
  border-radius: 2px;
  height: 130px;
}
#job_information{height: 130px;}
#CustomersList .ui.selection.dropdown .menu {
    border-top: 1px solid #d4d0c8 !important;
}
@media(max-width:1100px){
  .table-productos {
    position: relative;
    display: block;
    padding-left: 15px;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-productos table {width:860px;}
}
@media(max-width:800px){
  .table-productos {max-width:800px;}
}

</style>
